import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-title-underline" }, "すべてのブックマークした動画", -1)
const _hoisted_3 = { class: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" }
const _hoisted_4 = { class: "flex items-center justify-center mt-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" お気に入りはありませんでした。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_thumbnail = _resolveComponent("video-thumbnail")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (_ctx.toArray(_ctx.bookmarks).length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedList, (bookmark) => {
                      return (_openBlock(), _createElementBlock("div", { key: bookmark }, [
                        (bookmark.video)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/video/${bookmark.video.id}`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_video_thumbnail, {
                                  video: bookmark.video
                                }, null, 8, ["video"])
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_base_pagination, {
                      pagedList: _ctx.pagedList,
                      "onUpdate:pagedList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagedList) = $event)),
                      originalList: _ctx.bookmarks,
                      pageSize: _ctx.pageSize
                    }, null, 8, ["pagedList", "originalList", "pageSize"])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_5
                ], 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}